import { OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Data } from '../../helpers';
import { DashboardService } from '../../dashboard';
import { Observable } from 'rxjs/Rx';
import { ErrorHandlerService } from '../../services';
import * as moment from 'moment';
import { ConfirmationService } from 'primeng/primeng';
var MyEarningComponent = /** @class */ (function () {
    function MyEarningComponent(data, dashboardService, errorHandlerService, confirmationService, router) {
        this.data = data;
        this.dashboardService = dashboardService;
        this.errorHandlerService = errorHandlerService;
        this.confirmationService = confirmationService;
        this.router = router;
        this.subscriptions = [];
        this.showSpinner = false;
        this.showOnlyOverlay = false;
        this.paymentallDetails = [];
        this.paymentDetails = [];
        this.sessionsDetails = [];
        this.meetingsDetails = [];
        this.sponsorshipDetails = [];
        this.balanceCount = 0;
        this.totalCount = 0;
        this.sessionCount = 0;
        this.meetingCount = 0;
        this.sponsorshipCount = 0;
        this.APIData = {};
        this.payOutStatus = false;
        this.filterEarning = ["All", "Sessions", "Meetings", "Sponsorship"];
    }
    MyEarningComponent.prototype.editDisplay = function (edit) {
        if (edit) {
            return "block";
        }
        else {
            return "none";
        }
    };
    MyEarningComponent.prototype.ngOnInit = function () {
        this.showSpinner = true;
        this.initFn();
    };
    MyEarningComponent.prototype.initFn = function () {
        var _this = this;
        this.sessionsDetails = [];
        this.meetingsDetails = [];
        var s1 = this.dashboardService.getPaymentDetails().subscribe(function (data) {
            _this.paymentDetails = data.payments;
            _this.APIData = data;
            if (data.payOutRequested) {
                _this.payOutStatus = true;
            }
            if (_this.paymentDetails.length > 0) {
                _this.paymentDetails.forEach(function (p) {
                    p.uvsityFees = "$" + p.uvsityFees.toFixed(2);
                    p.totalAmount = "$" + p.totalAmount;
                    p.userAmount = "$" + p.userAmount;
                    p.occurence = moment(p.occurence).format('DD/MMM/YYYY').toString();
                    if (p.paymentSource == "Sessions") {
                        _this.sessionsDetails.push(p);
                    }
                    else if (p.paymentSource == "Sponsorship") {
                        _this.sponsorshipDetails.push(p);
                    }
                    else {
                        _this.meetingsDetails.push(p);
                    }
                });
            }
            _this.paymentallDetails = _this.paymentDetails;
            _this.balanceCount = data.totalPayable;
            _this.totalCount = data.totalEarnings;
            _this.sessionCount = data.sessionEarnings;
            _this.meetingCount = data.meetingEarnings;
            _this.sponsorshipCount = data.sessionSponsorshipEarnings;
            // this.balanceCount = (data.totalPayable > 150) ? data.totalPayable - 100 : 0;
            // this.totalCount = (data.totalEarnings > 150) ? data.totalEarnings - 100 : 0;
            // this.sessionCount = (data.sessionEarnings > 150) ? data.sessionEarnings - 100 : 0;
            // this.meetingCount = (data.meetingEarnings > 150) ? data.meetingEarnings - 100 : 0;
            // this.counterFn(data.totalPayable, 1);
            // this.counterFn(data.totalEarnings, 2);
            // this.counterFn(data.sessionEarnings, 3);
            // this.counterFn(data.meetingEarnings, 4);
            _this.showSpinner = false;
        }, function (error) {
            _this.showSpinner = false;
            _this.handleError(error);
        });
        this.subscriptions.push(s1);
    };
    MyEarningComponent.prototype.filterTransaction = function (e) {
        console.log("e", e);
        if (e.target.value == "all") {
            this.paymentallDetails = this.paymentDetails;
        }
        else if (e.target.value == "session") {
            this.paymentallDetails = this.sessionsDetails;
        }
        else if (e.target.value == "meeting") {
            this.paymentallDetails = this.meetingsDetails;
        }
        else if (e.target.value == "sponsorship") {
            this.paymentallDetails = this.sponsorshipDetails;
        }
    };
    MyEarningComponent.prototype.counterFn = function (maxNumber, type) {
        var _this = this;
        var that = this;
        if (type == 1) {
            this.balanceCounter = Observable.interval(50).subscribe(function (x) {
                if (that.balanceCount < maxNumber) {
                    that.balanceCount++;
                }
                else {
                    that.balanceCount = _this.APIData.totalPayable;
                    that.sessionCounter.unsubscribe();
                }
            }, function (error) { _this.handleError(error); });
        }
        if (type == 2) {
            this.totalCounter = Observable.interval(50).subscribe(function (x) {
                if (that.totalCount < maxNumber) {
                    that.totalCount++;
                }
                else {
                    that.totalCount = _this.APIData.totalEarnings;
                    that.meetingCounter.unsubscribe();
                }
            }, function (error) { _this.handleError(error); });
        }
        if (type == 3) {
            this.sessionCounter = Observable.interval(50).subscribe(function (x) {
                if (that.sessionCount < maxNumber) {
                    that.sessionCount++;
                }
                else {
                    that.sessionCount = _this.APIData.sessionEarnings;
                    that.sessionCounter.unsubscribe();
                }
            }, function (error) { _this.handleError(error); });
        }
        if (type == 4) {
            this.meetingCounter = Observable.interval(50).subscribe(function (x) {
                if (that.meetingCount < maxNumber) {
                    that.meetingCount++;
                }
                else {
                    that.meetingCount = _this.APIData.meetingEarnings;
                    that.meetingCounter.unsubscribe();
                }
            }, function (error) { _this.handleError(error); });
        }
    };
    MyEarningComponent.prototype.payout = function () {
        var _this = this;
        this.showSpinner = true;
        this.confirmationService.confirm({
            message: "Do you really want to withdraw now?",
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: function () {
                var s3 = _this.dashboardService.payoutCourse(_this.dashboardService.userdata.userDetailsId).subscribe(function (data) {
                    console.log("Does it have paypal configuration error? =" + data.configurePaypal);
                    if (data.configurePaypal) {
                        _this.showSpinner = false;
                        console.log("show confirmation");
                        _this.confirmationService.confirm({
                            message: "In order to process your payout request,you need to activate your payment information under [my account]. Do you want to configure it now?",
                            header: 'Confirmation',
                            icon: 'pi pi-exclamation-triangle',
                            accept: function () {
                                _this.router.navigate(['dashboard/myaccount']);
                            },
                            reject: function () {
                                // do nothing
                            }
                        });
                    }
                    else {
                        console.log("Paypal configuration active, you can proceed");
                        _this.initFn();
                    }
                }, function (error) {
                    _this.showSpinner = false;
                    _this.handleError(error);
                });
                _this.subscriptions.push(s3);
            },
            reject: function () {
                _this.showSpinner = false;
            }
        });
    };
    MyEarningComponent.prototype.handleError = function (error) {
        //console.log("The error inside the Error Handler==>" + error);
        var url = error.url;
        //console.log("The URL of the error==>"+error.url);
        if (url == undefined) {
            return;
        }
        //console.log("Throwing the error now. Shall call the errorHandlerService throwError method");
        this.errorHandlerService.throwError(error);
    };
    MyEarningComponent.prototype.ngOnDestroy = function () {
        this.subscriptions.forEach(function (element) {
            element.unsubscribe();
        });
    };
    return MyEarningComponent;
}());
export { MyEarningComponent };
//# sourceMappingURL=myEarning.component.js.map